"use client";

import styles from "./styles.module.scss";
import Image from "next/image";
import logo from "../../../assets/images/logo.svg";
import Link from "next/link";
import uniqid from "uniqid";
import { MyButton } from "@/components/atoms";
import navs from "@/data/navs";
import classNames from "classnames";
import menu from "../../../assets/images/menu.svg";
import { useRef, useState } from "react";
import close from "../../../assets/images/close.svg";
import { usePathname, useRouter } from "next/navigation";

const Navbar = ({ mainId }: { mainId?: string }) => {
  const router = useRouter();
  const refHeader = useRef<HTMLElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const pathname = usePathname();

  const handleOpenMenu = (open: boolean) => {
    const mainEl = document.getElementById(mainId || "");
    const menuMobile = document.getElementById("menu-mobile");
    if (refHeader.current && menuMobile) {
      if (open) {
        menuMobile.classList.add(styles.openMenuMobile);
        setTimeout(() => {
          if (mainEl) mainEl.style.marginTop = "112px";
          refHeader?.current?.classList.add(styles.headerWhenOpenMenu);
        }, 500);
      } else {
        menuMobile.classList.remove(styles.openMenuMobile);
        refHeader.current.classList.remove(styles.headerWhenOpenMenu);
        if (mainEl) mainEl.style.marginTop = "0px";
      }
    }
  };

  const handleClickMenu = () => {
    const current = !open;
    handleOpenMenu(current);
    setOpen(current);
  };

  const closeMenuMobile = () => {
    const current = false;
    handleOpenMenu(current);
    setOpen(current);
  };

  const handleClickContactBtn = () => {
    router.push("/contact");
  };

  return (
    <>
      <header id="navbar-desktop" ref={refHeader} className={styles.navbar}>
        <div className={styles.logo}>
          <Link
            href="/"
            onClick={(e) => {
              e.preventDefault();
              router.push("/");
              closeMenuMobile();
            }}
          >
            <Image
              src={logo}
              width={391}
              height={21}
              priority
              alt="Conckenpot Paysage Logo"
              className={styles.logo_img}
            />
          </Link>
        </div>
        <nav className={styles.navs}>
          {navs.map(({ label, url }) => (
            <div className={styles.nav} key={uniqid(label)}>
              <Link
                href={url}
                className={classNames(
                  styles.link,
                  label === "Jobs" ? styles.jobs : "",
                  { [styles.active]: pathname === url }
                )}
              >
                {label}
              </Link>
            </div>
          ))}
          <MyButton
            onClick={handleClickContactBtn}
            className={styles.btn_contact}
            label="Contact"
          />
        </nav>
        <div className={styles.menu_btn}>
          <button onClick={handleClickMenu}>
            {open ? (
              <Image src={close} width={27} height={17} alt="close" />
            ) : (
              <Image src={menu} width={27} height={17} alt="menu" />
            )}
          </button>
        </div>
      </header>
      <div className={styles.menuMobile} id="menu-mobile">
        <div className={styles.navs_container}>
          {[
            ...navs,
            {
              label: "Contact",
              url: "/contact",
            },
          ].map(({ label, url }) => (
            <Link
              href={url}
              onClick={(e) => {
                e.preventDefault();
                router.push(url);
                closeMenuMobile();
              }}
              key={uniqid()}
              className={classNames(styles.link_nav, {
                [styles.active_menu_mobile]: url === pathname,
              })}
            >
              <span>{label}</span>
            </Link>
          ))}
        </div>
        <div className={styles.separator}></div>
        <div className={styles.contact_container}>
          <a href="tel:03.20.29.06.24">03.20.29.06.24</a>
          <p>RN 41, 59480 Illies / La Bassée </p>
        </div>
      </div>
    </>
  );
};

export default Navbar;
